const _siteMessageTranslations = {
  en: {
    warning: "Warning!",
    loggOff: "You will be logged off in 5 mins. Please save your work!",
    error: "Error!",
    success: "Success!",
    info: "Info!",
    aiName: "Ahmed AI",
    aiWelcome:
      "Welcome to Ahmed AI! I'm here to help you create effective and insightful surveys. To get started, simply tell me what type of survey you need, and I'll do the rest.",
    aiDailyLimit:
      "Daily limit for AI usage has been reached. Please try again tomorrow.",
    aiSuccess: "Successfully generated form.",
    aiUsageLimit:
      "AI Usage limit has been reached. Please contact your administrator.",
  },
  ar: {
    warning: "تحذير!",
    loggOff: "سوف تخرج خلال 5 دقائق. الرجاء حفظ عملك!",
    error: "هناك خطأ",
    success: "نجاح",
    info: "الاعلام",
    aiName: "أحمد مساعد",
    aiWelcome:
      "مرحباً بكم مع أحمد مساعد الذكاء الاصطناعي! أنا هنا لمساعدتكم في إنشاء استطلاعات فعّالة ومفيدة. للبدء، ما عليك إلا إبلاغي بنوع الاستطلاع أو الاستمارة، وسأقوم أنا بالباقي",
    aiDailyLimit:
      "تم الوصول إلى الحد اليومي لاستخدام الذكاء الاصطناعي ، الرجاء المحاولة مرة أخرى غداً.",
    aiSuccess: "تم إنشاء النموذج بنجاح.",
    aiUsageLimit:
      "تم الوصول إلى الحد الأعلى لاستخدام خاصية الذكاء الاصطناعي. الرجاء الاتصال بمسؤول النظام.",
  },
};

setLoggedUserDetails();
runPageLoadValidations();

const _emailRegex =
  /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
const _passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/;

function validateRequired(data, shouldHighlight = true) {
  let isValid = true;
  let count = 0;
  let firstKey;
  if (typeof data === "object" && data !== null && data !== undefined) {
    for (const key in data) {
      if (data[key] === "" || data[key] === null || data[key] === undefined) {
        if (shouldHighlight) {
          $(`#${key}:visible`).addClass("is-invalid").addClass("was-validated");
          if (count === 0) {
            firstKey = key;
            count++;
          }
        }
        isValid = false;
      } else {
        $(`#${key}:visible`)
          .removeClass("is-invalid")
          .removeClass("was-validated");
      }
    }
  } else {
    if (data === "" || data === null || data === undefined) {
      if (shouldHighlight) {
        $(`#${key}:visible`).addClass("is-invalid").addClass("was-validated");
        if (count === 0) {
          firstKey = key;
          count++;
        }
      }
      isValid = false;
    } else {
      $(`#${key}:visible`)
        .removeClass("is-invalid")
        .removeClass("was-validated");
    }
  }

  if (firstKey) {
    document.getElementById(firstKey).scrollIntoView();
    $(`#${firstKey}`).focus();
  }

  return isValid;
}

function validateEmail(email) {
  let isValid = true;
  if (
    email === "" ||
    email === null ||
    email === undefined ||
    !_emailRegex.test(email)
  ) {
    isValid = false;
  }
  return isValid;
}

function validatePassword(password) {
  let isValid = true;
  if (
    password === "" ||
    password === null ||
    password === undefined ||
    !_passwordRegex.test(password)
  ) {
    isValid = false;
  }
  return isValid;
}

function getUser() {
  const userDetails = sessionStorage.getItem("eqp_user");
  if (!userDetails) {
    window.location = "/login";
  }
  return JSON.parse(userDetails);
}

function getToken() {
  const user = getUser();
  return user.token;
}

function storeUser(user) {
  sessionStorage.setItem("eqp_user", JSON.stringify(user));
}

//let isLoginExpiryAccepted = false;
function initiateLoginExpiryProcess() {
  const loginExpiryInterval = setInterval(() => {
    // const tokenJson = parseJwt();
    // const offset = Math.abs(new Date().getTimezoneOffset());
    // const offSetDiff = parseInt(tokenJson.toffset / 10000) - offset * 60 * 1000;
    // const exp = new Date(tokenJson.exp * 1000 + offSetDiff);
    // const timeRemaining = (exp - new Date()) / (1000 * 60);
    // console.log(timeRemaining);
    let timeRemaining = parseInt(
      sessionStorage.getItem("isLoginExpiryTimeRemaining")
    );
    let isLoginExpiryAccepted = sessionStorage.getItem("isLoginExpiryAccepted");

    timeRemaining -= 5;
    sessionStorage.setItem("isLoginExpiryTimeRemaining", timeRemaining);

    if (timeRemaining < 300 && isLoginExpiryAccepted === "false") {
      showWarning(getMessageForUserLanguage("loggOff"), false, () => {
        isLoginExpiryAccepted = true;
        sessionStorage.setItem("isLoginExpiryAccepted", true);
      });
    }

    if (timeRemaining <= 0) {
      clearInterval(loginExpiryInterval);
      logout();
    }
  }, 5000);
}

function showLoader(message) {
  $("body").append(`
    <div class="loader-container-eqp">
      <div class="loadercover-eqp"></div>
      <div class="loader-wrapper-eqp">
          <div class='loaderboxes'>
              <div class='loaderbox loaderbox-box1'></div>
              <div class='loaderbox loaderbox-box2'></div>
              <div class='loaderbox loaderbox-box3'></div>
              <div class='loaderbox loaderbox-box4'></div>
          </div>
          <div class="loader-message">

          </div>
      </div>
    </div>
  `);

  //$(".loader-container").show();
  if (message) {
    $(".loader-container-eqp .loaderboxes").css({ top: "0" });
    $(".loader-container-eqp .loader-message").text(message);
  } else {
    $(".loader-container-eqp .loaderboxes").css({ top: "50px" });
  }
}

function hideLoader() {
  $(".loader-container-eqp").remove();
  $(".loader-container-eqp .loaderboxes").css({ top: "0" });
}

function logout() {
  var user = getUser();
  sessionStorage.clear();

  $.ajax({
    url: `${__appUrl}/api/authentication/logout`,
    async: true,
    type: "GET",
    contentType: "application/json;charset=UTF-8",
    success: function (response) {
      window.location = "/";
    },
    error: function (err) {
      const error = getError(err);
      showError(error.messages);

      storeUser(user);
    },
  });
}

function getError(error) {
  if (error.status === 401) {
    const pageName = $(".page-name").text();
    return {
      messages: `Access denied for ${pageName}.`,
      type: "Un-authorized",
    };
  }

  if (error.responseJSON) {
    return {
      messages: error.responseJSON.errors.join("\n"),
      type: error.responseJSON.type,
    };
  }

  const errorVal = JSON.parse(error.responseText);

  return {
    messages: errorVal.errors.join("\n"),
    type: errorVal.type,
  };
}

// Alert handlers

function showSuccess(message, showCancelBtn = false) {
  Swal.fire({
    title: getMessageForUserLanguage("success"),
    text: message,
    icon: "success",
    confirmButtonText: "Ok",
    showCancelButton: showCancelBtn,
  });
}

function showSuccess(message, showCancelBtn = false, successFunc) {
  Swal.fire({
    title: getMessageForUserLanguage("success"),
    text: message,
    icon: "success",
    confirmButtonText: "Ok",
    showCancelButton: showCancelBtn,
  }).then((result) => {
    if (result.isConfirmed && successFunc) {
      successFunc();
    }
  });
}

function showSuccessSurveySubmission(message, successFunc) {
  Swal.fire({
    title: getMessageForUserLanguage("success"),
    text: message,
    icon: "success",
    confirmButtonText: "Ok",
    showCancelButton: false,
  }).then((result) => {
    if (successFunc) {
      successFunc();
    }
  });
}

function showError(message, showCancelBtn = false) {
  Swal.fire({
    title: getMessageForUserLanguage("error"),
    text: message,
    icon: "error",
    confirmButtonText: "Ok",
    showCancelButton: showCancelBtn,
  });
}

function showInfo(message, showCancelBtn = false) {
  Swal.fire({
    title: getMessageForUserLanguage("info"),
    text: message,
    icon: "info",
    confirmButtonText: "Ok",
    showCancelButton: showCancelBtn,
  });
}

function showWarning(message, showCancelBtn = false, okFunc, cancelFunction) {
  Swal.fire({
    title: getMessageForUserLanguage("warning"),
    text: message,
    icon: "warning",
    confirmButtonText: "Ok",
    showCancelButton: showCancelBtn,
  }).then((result) => {
    if (result.isConfirmed && okFunc) {
      okFunc();
    } else if (cancelFunction) {
      cancelFunction();
    }
  });
}

function getMessageForUserLanguage(message) {
  if (!_userLanguage) {
    _userLanguage = "en";
  }
  return _siteMessageTranslations[_userLanguage][message];
}

function toCamelCase(str) {
  if (str.toUpperCase() === str) {
    return str.toLowerCase();
  }
  return str.charAt(0).toLowerCase() + str.slice(1);
}

function formateDateForInput(date) {
  const d = new Date(date);
  const rDate = `${d.getFullYear()}-${formatGetMonth(d)}-${formatGetDate(d)}`;
  return rDate;
}

function formatDate(date) {
  if (!date) {
    return "";
  }

  const d = new Date(date);
  const rDate = `${d.getFullYear()}/${formatGetMonth(d)}/${formatGetDate(d)}`;
  return rDate;
}

function formatDateForSurveyForm(date, format = "dd/MM/yyyy") {
  let formatParts = [];
  let dateParts = [];
  if (format.includes("/")) {
    formatParts = format.split("/");
    dateParts = date.split(" ")[0].split("/");
  } else {
    formatParts = format.split("-");
    dateParts = date.split(" ")[0].split("-");
  }

  const year = dateParts[formatParts.indexOf("yyyy")];
  const month = dateParts[formatParts.indexOf("MM")];
  const day = dateParts[formatParts.indexOf("dd")];

  return new Date(`${year}/${month}/${day}`).toISOString();
}

function formatDateTimeForSurveyForm(dateTime, format) {
  var d = moment(dateTime);

  if (format.includes("dd")) {
    format = format.replace("dd", "DD");
  }

  return d.format(format);
}

function formatGetMonth(d) {
  let month = d.getMonth() + 1;
  if (month.toString().length > 1) {
    return month;
  }

  return `0${month}`;
}

function formatGetDate(d) {
  let date = d.getDate();
  if (date.toString().length > 1) {
    return date;
  }

  return `0${date}`;
}

function formatDateMonth(date) {
  var d = date.split("/");
  var rDate = d[1] + "/" + d[0] + "/" + d[2];
  return rDate;
}

function formatTime(dateTime) {
  var d = new Date(dateTime);
  var rTime =
    d.getHours() +
    ":" +
    d.getMinutes() +
    ":" +
    d.getSeconds() +
    ":" +
    d.getMilliseconds();
  return rTime;
}

function formatDateTime(dateTime) {
  return `${formatDate(dateTime)} ${formatTime(dateTime)}`;
}

function formatHour(dateTime) {
  const hour = dateTime.getHours();

  if (hour < 10) {
    return `0${hour}`;
  }

  return hour;
}

function formatMinute(dateTime) {
  const min = dateTime.getMinutes();

  if (min < 10) {
    return `0${min}`;
  }

  return min;
}

function formatDateTimePicker(date, isForSave, timeZoneOffSet = 0) {
  var d = "";
  var _d = isForSave
    ? moment(date).toDate()
    : moment(date).add(new Date().getTimezoneOffset(), "m").toDate();
  if (date) {
    if (isForSave) {
      d =
        _d.getFullYear() +
        "-" +
        (parseInt(_d.getMonth() + 1) < 10
          ? "0" + parseInt(_d.getMonth() + 1)
          : parseInt(_d.getMonth() + 1)) +
        "-" +
        (parseInt(_d.getDate()) < 10 ? "0" + _d.getDate() : _d.getDate()) +
        " " +
        _d.getHours() +
        ":" +
        _d.getMinutes() +
        ":" +
        "00";
    } else {
      d = `${formatGetDate(_d)}/${formatGetMonth(
        _d
      )}/${_d.getFullYear()} ${formatHour(_d)}:${formatMinute(_d)}`;
    }
  }
  return d;
}

function formatYesNo(value) {
  if (value) {
    return "Yes";
  }

  return "No";
}

function extractFromYesNo(value) {
  if (value === "Yes") {
    return true;
  }

  return false;
}

function formatEnabledDisabled(value) {
  if (value) {
    return "Enabled";
  }

  return "Disabled";
}

function extractFromEnabledDisabled(value) {
  if (value === "Enabled") {
    return true;
  }

  return false;
}

function formatNull(data) {
  if (data === null || data === undefined || data === "null") {
    return "";
  }
  return data;
}

function formatHiddenTableColumn(data, colShown) {
  let outputHtml = "<ul>";
  for (let i = colShown - 1; i < data.length; i++) {
    outputHtml += `<li>${data[i]}</li>`;
  }
  outputHtml += "</ul";

  return outputHtml;
}

$(document).on(
  "click",
  ".side-nav-menu .nav-menu li a:first-child",
  function () {
    toggleSideNav(this);
  }
);

function toggleSideNav(e) {
  let classList = $(e).parent().find("ul").prop("class")?.split(" ");
  if (classList?.includes("active")) {
    const activeIndex = classList.indexOf("active");
    classList.splice(activeIndex, 1);

    $(e).parent().find("ul").prop("class", classList.join(" "));
    $(e).find("em").removeClass("fa-angle-up");
    $(e).find("em").addClass("fa-angle-down");
  } else {
    $(e).parent().find("ul").addClass("active");
    $(e).find("em").removeClass("fa-angle-down");
    $(e).find("em").addClass("fa-angle-up");
  }
}

$(document).on("click", '[data-action="panel-collapse"]', function () {
  const classList = $(this)
    .closest(".panel")
    .children(".panel-container")
    .prop("class");
  if (classList.includes("collapse")) {
    $(this)
      .closest(".panel")
      .children(".panel-container")
      .removeClass("collapse");
  } else {
    $(this).closest(".panel").children(".panel-container").addClass("collapse");
  }
});

$(document).on("click", '[data-action="panel-fullscreen"]', function () {
  const classList = $(this).closest(".panel").prop("class");
  if (classList.includes("panel-fullscreen")) {
    $(this).closest(".panel").removeClass("panel-fullscreen");
    $(this).closest(".panel").find('[data-action="panel-collapse"]').show();
    $(this).closest(".panel").find('[data-action="panel-close"]').show();
  } else {
    $(this).closest(".panel").addClass("panel-fullscreen");
    $(this).closest(".panel").find('[data-action="panel-collapse"]').hide();
    $(this).closest(".panel").find('[data-action="panel-close"]').hide();
  }
});

$(document).on("click", '[data-action="panel-close"]', function () {
  $(this).closest(".panel").remove();
});

$(document).on("click", '[data-class="mobile-nav-on"]', function () {
  $("body").append(`<div class="side-nav-cover"></div>`);
  $(".page-sidebar").addClass("active");
});

$(document).on("click", ".side-nav-cover", function () {
  $(".page-sidebar").removeClass("active");
  $(this).remove();
});

// Datatable initializer

function toggleHiddenColumnsInDatatable(e, dt) {
  const rowLength = dt.rows(".selected").data()[0].length;
  const targetRow = $(e).find('[role="row"].selected');
  $(targetRow).addClass("parent");
  const colsShown = $(targetRow).find("td:visible").length;
  if (rowLength != colsShown) {
    $(targetRow).after(`
    <tr>
      <td class="child" colspan="${colsShown}">
        ${formatHiddenTableColumn(dt.rows(".selected").data()[0], colsShown)}
      </td>
    </tr>`);
  }
}

var initApp = (function (e) {
  return (
    (e.listFilter = function (t, e, o) {
      o ? $(o).addClass("js-list-filter") : $(t).addClass("js-list-filter"),
        $(e)
          .change(function () {
            var e = $(this).val().toLowerCase(),
              o = $(t).next().filter(".js-filter-message");
            return (
              1 < e.length
                ? ($(t)
                    .find(
                      $(
                        "[data-filter-tags]:not([data-filter-tags*='" +
                          e +
                          "'])"
                      )
                    )
                    .parentsUntil(t)
                    .removeClass("js-filter-show")
                    .addClass("js-filter-hide"),
                  $(t)
                    .find($("[data-filter-tags*='" + e + "']"))
                    .parentsUntil(t)
                    .removeClass("js-filter-hide")
                    .addClass("js-filter-show"),
                  o &&
                    o.text(
                      "showing " +
                        $(t).find("li.js-filter-show").length +
                        " from " +
                        $(t).find("[data-filter-tags]").length +
                        " total"
                    ))
                : ($(t)
                    .find("[data-filter-tags]")
                    .parentsUntil(t)
                    .removeClass("js-filter-hide js-filter-show"),
                  o && o.text("")),
              !1
            );
          })
          .keyup(
            $.debounce(myapp_config.filterDelay, function (e) {
              $(this).change();
            })
          );
    }),
    (e.loadScript = function (e, o) {
      if (myapp_config.jsArray[e])
        myapp_config.debugState &&
          console.log("This script was already loaded: " + e);
      else {
        var t = jQuery.Deferred(),
          n = document.getElementsByTagName("body")[0],
          i = document.createElement("script");
        (i.type = "text/javascript"),
          (i.src = e),
          (i.onload = function () {
            t.resolve();
          }),
          n.appendChild(i),
          (myapp_config.jsArray[e] = t.promise());
      }
      myapp_config.jsArray[e].then(function () {
        "function" == typeof o && o();
      });
    }),
    (e.saveSettings = function () {
      "undefined" != typeof saveSettings &&
      $.isFunction(saveSettings) &&
      myapp_config.storeLocally
        ? (initApp.accessIndicator(),
          saveSettings(),
          myapp_config.debugState &&
            console.log(
              "Theme settings: \n" + localStorage.getItem("themeSettings")
            ))
        : console.log("save function does not exist");
    }),
    (e.resetSettings = function () {
      myapp_config.root_.removeClass(function (e, o) {
        return (o.match(/(^|\s)(nav-|header-|mod-|display-)\S+/g) || []).join(
          " "
        );
      }),
        $(myapp_config.mythemeAnchor).attr("href", ""),
        initApp.checkNavigationOrientation(),
        initApp.saveSettings(),
        myapp_config.debugState && console.log("App reset successful");
    }),
    (e.factoryReset = function () {
      initApp.playSound("media/sound", "messagebox"),
        $(".js-modal-settings").modal("hide"),
        "undefined" != typeof bootbox
          ? bootbox.confirm({
              title:
                "<i class='fal fa-exclamation-triangle text-warning mr-2'></i> You are about to reset all of your localStorage settings",
              message:
                "<span><strong>Warning:</strong> This action is not reversable. You will lose all your layout settings.</span>",
              centerVertical: !0,
              swapButtonOrder: !0,
              buttons: {
                confirm: {
                  label: "Factory Reset",
                  className: "btn-warning shadow-0",
                },
                cancel: {
                  label: "Cancel",
                  className: "btn-success",
                },
              },
              className: "modal-alert",
              closeButton: !1,
              callback: function (e) {
                1 == e &&
                  (localStorage.clear(),
                  initApp.resetSettings(),
                  location.reload());
              },
            })
          : confirm(
              "You are about to reset all of your localStorage to null state. Do you wish to continue?"
            ) &&
            (localStorage.clear(), initApp.resetSettings(), location.reload()),
        myapp_config.debugState && console.log("App reset successful");
    }),
    (e.accessIndicator = function () {
      myapp_config.root_
        .addClass("saving")
        .delay(600)
        .queue(function () {
          return $(this).removeClass("saving").dequeue(), !0;
        });
    }),
    (e.pushSettings = function (e, o) {
      return (
        0 != o && localStorage.setItem("themeSettings", ""),
        myapp_config.root_.addClass(e),
        initApp.checkNavigationOrientation(),
        0 != o && initApp.saveSettings(),
        e
      );
    }),
    (e.getSettings = function () {
      return myapp_config.root_
        .attr("class")
        .split(/[^\w-]+/)
        .filter(function (e) {
          return /^(nav|header|mod|display)-/i.test(e);
        })
        .join(" ");
    }),
    (e.playSound = function (e, o) {
      var t = document.createElement("audio");
      navigator.userAgent.match("Firefox/")
        ? t.setAttribute("src", e + "/" + o + ".ogg")
        : t.setAttribute("src", e + "/" + o + ".mp3"),
        t.addEventListener(
          "load",
          function () {
            t.play();
          },
          !0
        ),
        t.pause(),
        t.play();
    }),
    (e.detectBrowserType = function () {
      return myapp_config.isChrome
        ? (myapp_config.root_.addClass("chrome webkit"), "chrome webkit")
        : myapp_config.isWebkit
        ? (myapp_config.root_.addClass("webkit"), "webkit")
        : myapp_config.isIE
        ? (myapp_config.root_.addClass("ie"), "ie")
        : void 0;
    }),
    (e.addDeviceType = function () {
      return (
        myapp_config.isMobile
          ? (myapp_config.root_.addClass("mobile"),
            (myapp_config.thisDevice = "mobile"))
          : (myapp_config.root_.addClass("desktop"),
            (myapp_config.thisDevice = "desktop")),
        myapp_config.thisDevice
      );
    }),
    (e.windowScrollEvents = function () {
      myapp_config.root_.is(
        ".nav-function-hidden.header-function-fixed:not(.nav-function-top)"
      ) && "desktop" === myapp_config.thisDevice
        ? myapp_config.root_logo.css({
            top: $(window).scrollTop(),
          })
        : myapp_config.root_.is(
            ".header-function-fixed:not(.nav-function-top):not(.nav-function-hidden)"
          ) &&
          "desktop" === myapp_config.thisDevice &&
          myapp_config.root_logo.attr("style", "");
    }),
    (e.checkNavigationOrientation = function () {
      switch (!0) {
        case myapp_config.root_.hasClass("nav-function-fixed") &&
          !myapp_config.root_.is(
            ".nav-function-top, .nav-function-minify, .mod-main-boxed"
          ) &&
          "desktop" === myapp_config.thisDevice:
          void 0 !== $.fn.slimScroll
            ? (myapp_config.navAnchor.slimScroll({
                height: "100%",
                color: "#fff",
                size: "4px",
                distance: "4px",
                railOpacity: 0.4,
                wheelStep: 10,
              }),
              document.getElementById(myapp_config.navHorizontalWrapperId) &&
                (myapp_config.navHooks.menuSlider("destroy"),
                myapp_config.debugState &&
                  console.log("----top controls destroyed")),
              myapp_config.debugState && console.log("slimScroll created"))
            : console.log("$.fn.slimScroll...NOT FOUND");
          break;
        case myapp_config.navAnchor.parent().hasClass("slimScrollDiv") &&
          "desktop" === myapp_config.thisDevice &&
          void 0 !== $.fn.slimScroll:
          myapp_config.navAnchor.slimScroll({
            destroy: !0,
          }),
            myapp_config.navAnchor.attr("style", ""),
            (events = jQuery._data(myapp_config.navAnchor[0], "events")),
            events && jQuery._removeData(myapp_config.navAnchor[0], "events"),
            myapp_config.debugState && console.log("slimScroll destroyed");
      }
      switch (!0) {
        case $.fn.menuSlider &&
          myapp_config.root_.hasClass("nav-function-top") &&
          0 == $("#js-nav-menu-wrapper").length &&
          !myapp_config.root_.hasClass("mobile-view-activated"):
          myapp_config.navHooks.menuSlider({
            element: myapp_config.navHooks,
            wrapperId: myapp_config.navHorizontalWrapperId,
          }),
            myapp_config.debugState &&
              console.log("----top controls created -- case 1");
          break;
        case myapp_config.root_.hasClass("nav-function-top") &&
          1 == $("#js-nav-menu-wrapper").length &&
          myapp_config.root_.hasClass("mobile-view-activated"):
          myapp_config.navHooks.menuSlider("destroy"),
            myapp_config.debugState &&
              console.log("----top controls destroyed -- case 2");
          break;
        case !myapp_config.root_.hasClass("nav-function-top") &&
          1 == $("#js-nav-menu-wrapper").length:
          myapp_config.navHooks.menuSlider("destroy"),
            myapp_config.debugState &&
              console.log("----top controls destroyed -- case 3");
      }
    }),
    (e.buildNavigation = function (e) {
      if ($.fn.navigation)
        return (
          $(e).navigation({
            accordion: myapp_config.navAccordion,
            speed: myapp_config.navSpeed,
            closedSign: '<em class="' + myapp_config.navClosedSign + '"></em>',
            openedSign: '<em class="' + myapp_config.navOpenedSign + '"></em>',
            initClass: myapp_config.navInitalized,
          }),
          e
        );
      myapp_config.debugState && console.log("WARN: navigation plugin missing");
    }),
    (e.destroyNavigation = function (e) {
      if ($.fn.navigation) return $(e).navigationDestroy(), e;
      myapp_config.debugState && console.log("WARN: navigation plugin missing");
    }),
    (e.appForms = function (o, t, e) {
      $(o).each(function () {
        var e = $(this).find(".form-control");
        e.on("focus", function () {
          !(function (e, o, t) {
            $(e).parents(o).addClass(t);
          })(this, o, t);
        }),
          e.on("blur", function () {
            !(function (e, o, t) {
              $(e).parents(o).removeClass(t);
            })(this, o, t);
          });
      });
    }),
    (e.mobileCheckActivation = function () {
      return (
        window.innerWidth < myapp_config.mobileResolutionTrigger
          ? (myapp_config.root_.addClass("mobile-view-activated"),
            (myapp_config.mobileMenuTrigger = !0))
          : (myapp_config.root_.removeClass("mobile-view-activated"),
            (myapp_config.mobileMenuTrigger = !1)),
        myapp_config.debugState &&
          console.log(
            "mobileCheckActivation on " +
              $(window).width() +
              " | activated: " +
              myapp_config.mobileMenuTrigger
          ),
        myapp_config.mobileMenuTrigger
      );
    }),
    (e.toggleVisibility = function (e) {
      var o = document.getElementById(e);
      "block" == o.style.display
        ? (o.style.display = "none")
        : (o.style.display = "block");
    }),
    (e.domReadyMisc = function () {
      if (
        ($(".custom-file input").change(function (e) {
          for (var o = [], t = 0; t < $(this)[0].files.length; t++)
            o.push($(this)[0].files[t].name);
          $(this).next(".custom-file-label").html(o.join(", "));
        }),
        $(".modal-backdrop-transparent").on("show.bs.modal", function (e) {
          setTimeout(function () {
            $(".modal-backdrop").addClass("modal-backdrop-transparent");
          });
        }),
        myapp_config.appDateHook.length)
      ) {
        var e = new Date(),
          o =
            [
              "Sunday",
              "Monday",
              "Tuesday",
              "Wednesday",
              "Thursday",
              "Friday",
              "Saturday",
            ][e.getDay()] +
            ", " +
            [
              "January",
              "February",
              "March",
              "April",
              "May",
              "June",
              "July",
              "August",
              "September",
              "October",
              "November",
              "December",
            ][e.getMonth()] +
            " " +
            e.getDate() +
            ", " +
            e.getFullYear();
        myapp_config.appDateHook.text(o);
      }
      initApp.checkNavigationOrientation();
      var t = localStorage.getItem("lastTab");
      if (
        ($('a[data-toggle="tab"]').on("shown.bs.tab", function (e) {
          localStorage.setItem("lastTab", $(this).attr("href"));
        }),
        t && $('[href="' + t + '"]').tab("show"),
        void 0 !== $.fn.slimScroll && "desktop" === myapp_config.thisDevice
          ? ($(
              ".custom-scroll:not(.disable-slimscroll) >:first-child"
            ).slimscroll({
              height: $(this).data("scrollHeight") || "100%",
              size: $(this).data("scrollSize") || "4px",
              position: $(this).data("scrollPosition") || "right",
              color: $(this).data("scrollColor") || "rgba(0,0,0,0.6)",
              alwaysVisible: $(this).data("scrollAlwaysVisible") || !1,
              distance: $(this).data("scrollDistance") || "4px",
              railVisible: $(this).data("scrollRailVisible") || !1,
              railColor: $(this).data("scrollRailColor") || "#fafafa",
              allowPageScroll: !1,
              disableFadeOut: !1,
            }),
            myapp_config.debugState &&
              console.log("%c✔ SlimScroll plugin active", "color: #148f32"))
          : (console.log(
              "WARN! $.fn.slimScroll not loaded or user is on desktop"
            ),
            myapp_config.root_.addClass("no-slimscroll")),
        void 0 !== initApp.listFilter &&
          $.isFunction(initApp.listFilter) &&
          $("[data-listfilter]").length)
      ) {
        var n = $("[data-listfilter]").attr("id"),
          i = $("[data-listfilter]").attr("data-listfilter");
        initApp.listFilter(i, "#" + n);
      }
      if (
        (void 0 !== $.fn.tooltip && $('[data-toggle="tooltip"]').length
          ? $('[data-toggle="tooltip"]').tooltip()
          : console.log("OOPS! bs.tooltip is not loaded"),
        void 0 !== $.fn.popover && $('[data-toggle="popover"]').length)
      ) {
        $.fn.tooltip.Constructor.Default.whiteList;
        $('[data-toggle="popover"]').popover({
          sanitize: !1,
        });
      }
      if (
        (void 0 !== $.fn.dropdown
          ? (Popper.Defaults.modifiers.computeStyle.gpuAcceleration = !1)
          : console.log("OOPS! bs.popover is not loaded"),
        $(document).on(
          "click",
          ".dropdown-menu:not(.js-auto-close)",
          function (e) {
            e.stopPropagation();
          }
        ),
        window.Waves && myapp_config.rippleEffect
          ? (Waves.attach(
              ".nav-menu:not(.js-waves-off) a, .btn:not(.js-waves-off):not(.btn-switch), .js-waves-on",
              ["waves-themed"]
            ),
            Waves.init(),
            myapp_config.debugState &&
              console.log("%c✔ Waves plugin active", "color: #148f32"))
          : myapp_config.debugState &&
            console.log("%c✘ Waves plugin inactive! ", "color: #fd3995"),
        myapp_config.root_.on("click touchend", "[data-action]", function (e) {
          var o = $(this).data("action");
          switch (!0) {
            case "toggle" === o:
              var t = $(this).attr("data-target") || myapp_config.root_,
                n = $(this).attr("data-class"),
                i = $(this).attr("data-focus");
              -1 !== n.indexOf("mod-bg-") &&
                $(t).removeClass(function (e, o) {
                  return (o.match(/(^|\s)mod-bg-\S+/g) || []).join(" ");
                }),
                $(t).toggleClass(n),
                $(this).hasClass("dropdown-item") &&
                  $(this).toggleClass("active"),
                null != i &&
                  setTimeout(function () {
                    $("#" + i).focus();
                  }, 200),
                ("undefined" == typeof classHolder && null == classHolder) ||
                  (initApp.checkNavigationOrientation(),
                  initApp.saveSettings());
              break;
            case "toggle-swap" === o:
              (t = $(this).attr("data-target")),
                (n = $(this).attr("data-class"));
              $(t).removeClass().addClass(n);
              break;
            case "panel-collapse" === o:
              (l = $(this).closest(".panel"))
                .children(".panel-container")
                .collapse("toggle")
                .on("show.bs.collapse", function () {
                  l.removeClass("panel-collapsed"),
                    myapp_config.debugState &&
                      console.log(
                        "panel id:" + l.attr("id") + " | action: uncollapsed"
                      );
                })
                .on("hidden.bs.collapse", function () {
                  l.addClass("panel-collapsed"),
                    myapp_config.debugState &&
                      console.log(
                        "panel id:" + l.attr("id") + " | action: collapsed"
                      );
                });
              break;
            case "panel-fullscreen" === o:
              (l = $(this).closest(".panel")).toggleClass("panel-fullscreen"),
                myapp_config.root_.toggleClass("panel-fullscreen"),
                myapp_config.debugState &&
                  console.log(
                    "panel id:" + l.attr("id") + " | action: fullscreen"
                  );
              break;
            case "panel-close" === o:
              function a() {
                l.fadeOut(500, function () {
                  $(this).remove(),
                    myapp_config.debugState &&
                      console.log(
                        "panel id:" + l.attr("id") + " | action: removed"
                      );
                });
              }
              var l = $(this).closest(".panel");
              "undefined" != typeof bootbox
                ? (initApp.playSound("media/sound", "messagebox"),
                  bootbox.confirm({
                    title:
                      "<i class='fal fa-times-circle text-danger mr-2'></i> Do you wish to delete panel <span class='fw-500'>&nbsp;'" +
                      l.children(".panel-hdr").children("h2").text().trim() +
                      "'&nbsp;</span>?",
                    message:
                      "<span><strong>Warning:</strong> This action cannot be undone!</span>",
                    centerVertical: !0,
                    swapButtonOrder: !0,
                    buttons: {
                      confirm: {
                        label: "Yes",
                        className: "btn-danger shadow-0",
                      },
                      cancel: {
                        label: "No",
                        className: "btn-default",
                      },
                    },
                    className: "modal-alert",
                    closeButton: !1,
                    callback: function (e) {
                      1 == e && a();
                    },
                  }))
                : confirm(
                    "Do you wish to delete panel " +
                      l.children(".panel-hdr").children("h2").text().trim() +
                      "?"
                  ) && a();
              break;
            case "theme-update" === o:
              if ($(myapp_config.mythemeAnchor).length)
                $(myapp_config.mythemeAnchor).attr(
                  "href",
                  $(this).attr("data-theme")
                );
              else {
                var r = $("<link>", {
                  id: myapp_config.mythemeAnchor.replace("#", ""),
                  rel: "stylesheet",
                  href: $(this).attr("data-theme"),
                });
                $("head").append(r);
              }
              null != $(this).attr("data-themesave") && initApp.saveSettings();
              break;
            case "app-reset" === o:
              initApp.resetSettings();
              break;
            case "factory-reset" === o:
              initApp.factoryReset();
              break;
            case "app-print" === o:
              window.print();
              break;
            case "app-loadscript" === o:
              var s = $(this).attr("data-loadurl"),
                c = $(this).attr("data-loadfunction");
              initApp.loadScript(s, c);
              break;
            case "lang" === o:
              var p = $(this).attr("data-lang").toString();
              $.i18n
                ? i18n.setLng(p, function () {
                    console.log(p.toLowerCase());
                    $("[data-i18n]").i18n();
                    $("html").attr("lang", p.toLowerCase());
                    location.hash = "#?lang=" + p.toLowerCase();
                    $("[data-i18n]").i18n(),
                      $("[data-lang]").removeClass("active"),
                      $(this).addClass("active");
                  })
                : initApp.loadScript("Scripts/i18n.js", function () {
                    $.i18n.init(
                      {
                        resGetPath: "Content/media/data/__lng__.json",
                        load: "unspecific",
                        fallbackLng: !1,
                        lng: p,
                      },
                      function (e) {
                        console.log(p.toLowerCase());
                        $("[data-i18n]").i18n();
                        $("html").attr("lang", p.toLowerCase());
                        location.hash = "#?lang=" + p.toLowerCase();
                      }
                    );
                  });
              break;
            case "app-fullscreen" === o:
              document.fullscreenElement ||
              document.mozFullScreenElement ||
              document.webkitFullscreenElement ||
              document.msFullscreenElement
                ? (document.exitFullscreen
                    ? document.exitFullscreen()
                    : document.msExitFullscreen
                    ? document.msExitFullscreen()
                    : document.mozCancelFullScreen
                    ? document.mozCancelFullScreen()
                    : document.webkitExitFullscreen &&
                      document.webkitExitFullscreen(),
                  myapp_config.debugState &&
                    console.log(
                      "%capp fullscreen toggle inactive! ",
                      "color: #ed1c24"
                    ))
                : (document.documentElement.requestFullscreen
                    ? document.documentElement.requestFullscreen()
                    : document.documentElement.msRequestFullscreen
                    ? document.documentElement.msRequestFullscreen()
                    : document.documentElement.mozRequestFullScreen
                    ? document.documentElement.mozRequestFullScreen()
                    : document.documentElement.webkitRequestFullscreen &&
                      document.documentElement.webkitRequestFullscreen(
                        Element.ALLOW_KEYBOARD_INPUT
                      ),
                  myapp_config.debugState &&
                    console.log("app fullscreen toggle active"));
              break;
            case "playsound" === o:
              var f = $(this).attr("data-soundpath") || "media/sound/",
                d = $(this).attr("data-soundfile");
              initApp.playSound(f, d);
          }
          $(this).tooltip("hide"),
            myapp_config.debugState && console.log("data-action clicked: " + o),
            e.stopPropagation(),
            e.preventDefault();
        }),
        navigator.userAgent.match(/IEMobile\/10\.0/))
      ) {
        var a = document.createElement("style");
        a.appendChild(
          document.createTextNode("@-ms-viewport{width:auto!important}")
        ),
          document.head.appendChild(a);
      }
      myapp_config.debugState &&
        console.log(
          "%c✔ Finished app.init() v" +
            myapp_config.VERSION +
            "\n---------------------------",
          "color: #148f32"
        );
    }),
    e
  );
})({});

// #endregion

// #region Utility

function generateExcel(
  data,
  sheetName = "sheet1",
  fileName = "file1",
  columns
) {
  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

  if (columns && columns.length > 0) {
    XLSX.utils.sheet_add_aoa(worksheet, [columns], { origin: "A1" });
  }

  const range = XLSX.utils.decode_range(worksheet["!ref"]);
  for (let row = range.s.r; row <= range.e.r; row++) {
    const cellAddress = XLSX.utils.encode_cell({ r: row, c: 1 }); // Column B (index 1)
    if (!worksheet[cellAddress]) continue;
    worksheet[cellAddress].t = "s"; // Set cell type to string
  }

  XLSX.writeFile(workbook, `${fileName}.xlsx`, { compression: true });
}

function parseJwt() {
  const token = getToken();
  let base64Url = token.split(".")[1];
  let base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  let jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  let payload = JSON.parse(jsonPayload);
  payload.access = JSON.parse(payload.access);

  return payload;
}

function getQueryParam(param) {
  const url = new URL(window.location.href);

  const params = new URLSearchParams(url.search);

  return params.get(param);
}

function getSurveyLink() {
  const queryParamLink = window.location.pathname
    .toLowerCase()
    .split("estebyan/");
  return queryParamLink[1];
}

function getQnaLink() {
  const queryParamLink = window.location.pathname
    .toLowerCase()
    .split("discussion/");
  return queryParamLink[1];
}

function selectPickerSetValue(selector, values) {
  $(`${selector}`).val(values);
  $(`${selector}`).selectpicker("refresh");
}

function selectPickerGetValues(selector) {
  let selectedValues = [];
  $(`${selector} option:selected`).each(function () {
    selectedValues.push($(this).val());
  });

  return selectedValues;
}

function selectPickerGetLabels(selector) {
  let selectedValues = [];
  $(`${selector} option:selected`).each(function () {
    selectedValues.push($(this).text());
  });

  return selectedValues;
}

function setLoggedUserDetails() {
  const userJson = sessionStorage.getItem("eqp_user");
  if (userJson) {
    const user = JSON.parse(userJson);

    $(".loggedin-user-name").text(user.name);
    $(".loggedin-user-email").text(user.email);

    $("[data-userrole]").each(function () {
      const requiredRoles = $(this).data("userrole");
      if (!requiredRoles.includes(user.role)) {
        $(this).remove();
      }
    });

    const access = parseJwt().access;
    if (!access.isLiveDashboardEnabled) {
      $("[data-livedashboard]").remove();
    }

    if (!access.isWorkflowEnabled) {
      $("[data-workflow]").remove();
    }

    // Login expiry process
    initiateLoginExpiryProcess();

    // AI assistant
    if (
      access.isAIAccessEnabled &&
      window.location.pathname.toLocaleLowerCase() === "/createoreditsurvey"
    ) {
      $(".btn-ai").css("display", "inline-block");
    }
  }
}

function runPageLoadValidations() {
  if (!sessionStorage.getItem("eqp_user")) {
    return;
  }
  const access = parseJwt().access;
  if (!access.isQnAEnabled) {
    $("[data-qna]").remove();
  }
}

function contactUs() {
  event.preventDefault();
  var validationData = {
    firstName: $("#firstName").val(),
    lastName: $("#lastName").val(),
    email: $("#email").val(),
    phone: $("#phone").val(),
    message: $("#message").val(),
  };

  const isValid = validateRequired(validationData);

  if (!isValid) {
    return;
  }

  var data = {
    name: `${$("#firstName").val()} ${$("#lastName").val()}`,
    email: $("#email").val(),
    phone: $("#phone").val(),
    message: $("#message").val(),
  };

  $.ajax({
    url: `${__appUrl}/api/notifications/email/contact-us`,
    async: false,
    type: "POST",
    dataType: "json",
    contentType: "application/json;charset=UTF-8",
    data: JSON.stringify(data),
    success: function (response) {
      $(".contact-us-message-response").html(`
        <div class="alert alert-success col-lg-12" role="alert">
        Message sent successfully.
        </div>
      `);
    },
    error: function (err) {
      $(".contact-us-message-response").html(`
        <div class="alert alert-danger col-lg-12" role="alert">
          Could not contact Datamining. Please try again after sometime.
        </div>
      `);
    },
  });
}

function toCamelCase(str) {
  return str
    .replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, (match, index) =>
      index === 0 ? match.toLowerCase() : match.toUpperCase()
    )
    .replace(/\s+/g, "");
}

// #endregion

// #region AI

function openAIAssistant() {
  if ($(".ai-assistant-container").prop("class").includes("show")) {
    closeAIAssistant();
    return;
  }
  $(".ai-assistant-container").removeClass("hide");
  $(".ai-assistant-container").addClass("show");

  //TODO: Add AI availability logic

  if (sessionStorage.getItem("isAIAssistantOpened") !== "true") {
    showAIAssistantLoader();

    setTimeout(() => {
      $.ajax({
        url: `${__appUrl}/api/aiservices/validate-ai-usage`,
        async: true,
        type: "GET",
        dataType: "json",
        contentType: "application/json;charset=UTF-8",
        headers: {
          authorization: `Bearer ${getToken()}`,
        },
        success: function (response) {
          hideAIAssistantLoader();

          if (response) {
            $(".ai-assistant-body").append(
              `<div class="comment comment-70 left">
                  <div class="comment-title">
                    ${_siteMessageTranslations[_userLanguage].aiName}
                  </div>
                  <div class="comment-content">
                    ${_siteMessageTranslations[_userLanguage].aiWelcome}
                  </div>
                </div>`
            );

            saveAIAssistanceMessages(
              _siteMessageTranslations[_userLanguage].aiName,
              _siteMessageTranslations[_userLanguage].aiWelcome
            );
          } else {
            $(".ai-assistant-body").append(
              `<div class="comment comment-70 left">
                  <div class="comment-title">
                    ${_siteMessageTranslations[_userLanguage].aiName}
                  </div>
                  <div class="comment-content">
                    ${_siteMessageTranslations[_userLanguage].aiDailyLimit}
                  </div>
                </div>`
            );

            saveAIAssistanceMessages(
              _siteMessageTranslations[_userLanguage].aiName,
              _siteMessageTranslations[_userLanguage].aiDailyLimit
            );
          }
        },
        error: function (err) {
          const error = getError(err);
          $(".ai-assistant-body").append(
            `<div class="comment comment-70 left">
                <div class="comment-title">
                ${_siteMessageTranslations[_userLanguage].aiName}
                </div>
                <div class="comment-content">
                  ${error.join("\n")}
                </div>
              </div>`
          );

          saveAIAssistanceMessages(
            _siteMessageTranslations[_userLanguage].aiName,
            `${error.join("\n")}`
          );
        },
      });
    }, 1000);
  } else {
    setAIAssistanceMessages(false);
  }

  sessionStorage.setItem("isAIAssistantOpened", true);
}

function closeAIAssistant() {
  $(".ai-assistant-container").removeClass("show");
  $(".ai-assistant-container").addClass("hide");
}

function showAIAssistantLoader() {
  $(".ai-assistant-body").append(`
    <div class="d-flex justify-content-center align-items-center w-100">
      <img src="/image/ai-loader.gif" class="ai-loader" alt="AI Loader" style="width: 32px;">
    </div>
  `);
}

function hideAIAssistantLoader() {
  $(".ai-assistant-body .ai-loader").remove();
}

function saveAIAssistanceMessages(party, message) {
  let messagesText = sessionStorage.getItem("aiAssistanceMessages");
  let messages;
  if (messagesText) {
    messages = JSON.parse(messagesText);
    messages[`${party}-${new Date().getTime()}`] = message;
  } else {
    messages = {};
    messages[`${party}-${new Date().getTime()}`] = message;
  }

  sessionStorage.setItem("aiAssistanceMessages", JSON.stringify(messages));
}

function setAIAssistanceMessage(party, message, withSave = true) {
  if (withSave) {
    saveAIAssistanceMessages(party, message);
  }

  $(".ai-assistant-body").append(
    `<div class="comment comment-70 ${party !== "Me" ? "left" : "right"}">
        <div class="comment-title">
          ${party}
        </div>
        <div class="comment-content">
          ${message}
        </div>
      </div>`
  );
}

function setAIAssistanceMessages(withSave = true) {
  let messagesText = sessionStorage.getItem("aiAssistanceMessages");
  $(".ai-assistant-body").html("");
  if (messagesText) {
    let messages = JSON.parse(messagesText);
    for (let key in messages) {
      setAIAssistanceMessage(key.split("-")[0], messages[key], withSave);
    }
  }
}

function sendAIQuery() {
  if (window.location.pathname.toLocaleLowerCase() === "/createoreditsurvey") {
    sendAISurveyCreationRequest();
  }
}

// #endregion

function cleanKey(key) {
  if (!key) return "";

  return key
    .replace(/\./g, "\\.")
    .replace(/:/g, "\\:")
    .replace(/'/g, "\\'")
    .replace(/"/g, `\\"`)
    .replace(/&/g, "&amp;");
}

// #endregion

// #region Additional user selectors

function initializeUserList(e) {
  const searchKey = $(e).val();
  if (searchKey.length <= 3) {
    return;
  }

  $.ajax({
    url: `${__appUrl}/api/users/search/${searchKey}`,
    async: true,
    type: "GET",
    dataType: "json",
    contentType: "application/json;charset=UTF-8",
    headers: {
      authorization: `Bearer ${getToken()}`,
    },
    success: function (response) {
      let availableUsers = response;
      $(e)
        .parent()
        .find(".user-tag .user-badge")
        .each(function () {
          const index = availableUsers.findIndex(
            (x) => x.email === $(this).data("useremail")
          );
          if (index !== -1) {
            availableUsers.splice(index, 1);
          }
        });
      const target = $(e).parent().find(".user-list");

      const oupputHtml = availableUsers.map((x) => {
        return `
          <div class="user-option" 
            data-userfullname="${x.fullName}" 
            data-useremail="${x.email}" onclick="selectUserOption(this)">
            <span>${x.fullName}</span>
            <span>${x.email}</span>
          </div>
        `;
      });

      $(target).removeClass("hidden");
      $(target).html(oupputHtml);
    },
  });
}

function selectUserOption(e) {
  const target = $(e).parent().parent().find(".user-tag");

  const userEmail = $(e).data("useremail");
  const userFullname = $(e).data("userfullname");

  const userListTarget = $(e).parent();
  $(userListTarget).html("");
  $(userListTarget).addClass("hidden");

  const userHtml = `
    <span class="badge bg-primary mt-1 user-badge" data-useremail="${userEmail}" data-userfullname="${userFullname}">
      ${userFullname}
      <i class="fa fa-times pointer ps-2" onclick="removeSelectedUser(this)" />
    </span>`;

  $(target).append(userHtml);
}

function removeSelectedUser(e) {
  $(e).parent().remove();
}

function closeUserList(e) {
  if (!$(e).val()) {
    const target = $(e).parent().find(".user-list");
    $(target).html("");
    $(target).addClass("hidden");
  }
}

function setUsers(users, selector) {
  if (users) {
    const userList = users.split(";");
    const target = $(`${selector}`).parent().find(".user-tag");
    let userHtml = "";
    for (let i = 0; i < userList.length; i++) {
      if (userList[i]) {
        const email = userList[i].split("~")[0];
        const name = userList[i].split("~")[1];

        userHtml += `
          <span class="badge bg-primary mt-1 user-badge" data-useremail="${email}" data-userfullname="${name}">
            ${name}
            <i class="fa fa-times pointer ps-2" onclick="removeSelectedUser(this)" />
          </span>`;
      }
    }
    $(target).html(userHtml);
  }
}

function getUsers(selector) {
  let users = "";
  const target = $(`${selector}`).parent().find(".user-tag");
  $(target)
    .find(".user-badge")
    .each(function () {
      users += `${$(this).data("useremail")}~${$(this).data("userfullname")};`;
    });

  if (!users) {
    return null;
  }

  return users;
}

function clearUsers(selector) {
  $(`${selector}`).val("");
  $(`${selector}`).parent().find(".user-tag").html("");
  $(`${selector}`).parent().find(".user-list").html("");
  $(`${selector}`).parent().find(".user-list").addClass("hidden");
}

// #endregion
